module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAY1BMVEUAAABBBQwAAAA/BQy4DyIKAQIkHgMsJQTOESZ5ChYYFAJ0YArKpxLMESYwBAkJBwFZSgjVsRP80RbSrxKsDiBlVAnzyhVmQncAcsbJEyogY67aSVn////rnabRHzP65ujeXWsvMdH5AAAAAXRSTlMAQObYZgAAAGVJREFUeAGdyjdaxkAMhOF31lo/7rj/EclQAX9AuCFUpE95Rn4kEp/kXJacqegTSyuVsy3R9az6VNTMjpxn99HguJqTZVqPxMZFQD/yPGB87XCf2sn9h+A25BYUkKH5/HCVXPkvb/h/Ge/PauuEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AG.png
// module id = 1070
// module chunks = 0